"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timing = void 0;
var Timing;
(function (Timing) {
    Timing["Future"] = "Future";
    Timing["Imminent"] = "Imminent";
    Timing["Immediate"] = "Immediate";
})(Timing = exports.Timing || (exports.Timing = {}));
//# sourceMappingURL=timing.js.map